import React, {Component} from 'react';
import Accounts from "./Accounts";
import {Grid, Container} from 'semantic-ui-react';
import Alerts from "./Alerts";
import Trends from "./Trends";
import Goals from "./Goals";
import Bills from "./Bills";

export default class Overview extends Component {

    componentDidMount() {
        // this.props.updateAuth(true);
    }

    render() {

        return (
            <Container>
                <Grid columns={2} stackable>
                    <Grid.Column>
                        <Accounts env={this.props.env} />
                        <Trends />
                    </Grid.Column>
                    <Grid.Column>
                        <Alerts />
                        <Goals />
                        <Bills />
                    </Grid.Column>
                </Grid>
            </Container>
        )

    }

}
